import { z } from 'zod';

/**
 * Mirrors `backend/app/api/status.py`'s `AgentResponse`/`AgentListResponse` for `GET /agents`.
 * This is an indicator, not a management surface: nothing here creates, revokes, or renews a
 * credential, and the credential itself never appears in the shape.
 */
/**
 * `workbook_availability` is a permissive string, not a closed enum: an agent or backend
 * ahead of this frontend build may report a new value, and this indicator must still parse
 * rather than crash - it only needs to know whether the value is exactly `"available"`.
 */
export const agentReportSchema = z.object({
  agent_version: z.string(),
  capabilities: z.array(z.string()),
  workbook_availability: z.string(),
  reported_at: z.string(),
  is_stale: z.boolean(),
});

export type AgentReport = z.infer<typeof agentReportSchema>;

export const agentSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.enum(['active', 'revoked']),
  last_heartbeat_at: z.string().nullable(),
  revoked_at: z.string().nullable(),
  is_stale: z.boolean(),
  last_report: agentReportSchema.nullable().optional(),
});

export type AgentSummary = z.infer<typeof agentSummarySchema>;

export const agentListResponseSchema = z.object({
  items: z.array(agentSummarySchema),
  delivery_available: z.boolean(),
  stale_after_seconds: z.number(),
});

export type AgentListResponse = z.infer<typeof agentListResponseSchema>;
